import { collection, doc, getDocs, increment, query, setDoc, updateDoc } from 'firebase/firestore'
import { fontType } from '../assets/extras'
import './styles/playerscomponent.css'

//Extras
import { IoMdClose } from "react-icons/io"
import { db } from '../assets/connections'
import { horas } from '../assets/datas'
import { compareDates, getCurrentDate } from '../assets/validator'

const Academias = ({variables, setVariables, showMessage}) => {

    //Variable que almacena los datos ordenados por dias
    var sortedDaysData = [
        [], //Lunes
        [], //Martes
        [], //Miercoles
        [], //Jueves
        [], //Viernes
        [], //Sabado
        [], //Domingo
    ]

    //Funcion que busca a que dia pertenece la clase
    const sortByDay = (clase) => {
        for(let i = 0; i < 7; i++){
            if(i === 0){ //Lunes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Lunes"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 1){ //Martes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Martes"){
                        sortedDaysData[i].push(clase)
                        cont ++;
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 2){ //Miercoles
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Miercoles"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 3){ //Jueves
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Jueves"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 4){ //Viernes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Viernes"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 5){ //Sabado
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Sabado"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 6){ //Domingo
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Domingo"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            }
        }
    }

    //Funcion que busca las clases de los centros
    const searchClasses = async (data) => {
        //Buscamos las clases de la academia
        await getDocs(query(collection(doc(db, data.path), "Clases"))).then(r => {
            var aux = []

            r.docs.map((v, i) => {
                const id = v.id
            
                //Validamos que esta sea solamente de las registradas, sin ser sustituciones ni extras
                var cont = parseInt(v.data().limite_jugadores) - parseInt(v.data().numero_jugadores)
                if(id.split("-").length === 1  && v.data().isGroup === true && cont >= 1){

                    if((v.data().numero_jugadores + v.data().clases_muestra) < v.data().limite_jugadores){
                        var dias_aux = []
                        v.data().dias_clase.map(v => {
                            dias_aux.push(v.dia)
                        })

                        var newObject = {
                            id: v.id,
                            ...v.data(),
                            path: v.ref.path
                        }

                        aux.push(newObject)
                    }
                    
                }
            })

            //Ordenamos cada clase de la lista de las categorias por dias
            for(let i = 0; i < aux.length; i++){
                //Recibimos una sola clase de la lista+
                sortByDay(aux[i])
            }

            var aux2 = []
            //Una vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
            //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
            for(let i = 0; i < sortedDaysData.length; i++){

                //Primero creamos una variable que contendra las horas de clase
                var h = horas.map((v, i) => [])

                for(let x = 0; x < sortedDaysData[i].length; x++){

                    //Creamos una variable que almacena las horas de comienzo de cada clase
                    var start = []

                    //Recorremos cada dia de las clases
                    for(let z = 0; z < sortedDaysData[i][x].dias_clase.length; z++){
                        //Las agregamos a la variable de almacenamiento de las horas
                        start.push(parseInt(sortedDaysData[i][x].dias_clase[z].de))
                    }

                    
                    //Ahora validamos recorriendo las horas a cual pertenece cada una
                    for(let z = 0; z < h.length; z++){
                        if(start.includes((z+1))){
                            h[z].push(sortedDaysData[i][x])
                            break
                        }
                    }

                }

                h.map((v, i) => {
                    v.map(v2 => {
                        aux2.push(v2)
                    })
                })

            }

            setVariables(prev => ({
                ...prev,
                selectedAcademy: {
                    id: data.id,
                    path: data.path
                },
                classes: aux2,
                selector: true
            }))
        }).catch(e => {
            console.log(e)
            setVariables(prev => ({
                ...prev,
            }))
            setTimeout(() => {
                showMessage("Error al obtener las clases muestra", "error")
            }, 100)
        })
    }

    //Funcion que selecciona la informacion de un centro
    const selectCenter = async (data) => {
        var object = {
            academia: variables.selectedAcademy.id,
            asistio: false,
            checked: false,
            correo: variables.selectedItem.data.correo,
            dias_clase: data.dias_clase,
            edad: variables.selectedItem.data.edad,
            fecha_clase: variables.selectedDate.newDate,
            id_clase: data.id,
            id_profesor: data.profesor_clase,
            isReserved: true,
            nivel: data.nivel,
            nombre: variables.selectedItem.data.nombre,
            nombre_clase: data.nombre_clase,
            nombre_profesor: data.nombre_profesor,
            ref: data.path,
            telefono: variables.selectedItem.data.telefono ? variables.selectedItem.data.telefono : "",
            sede: data.sede || "",
            nombre_sede: data.nombre_sede || "",
        }

        if(compareDates(variables.selectedDate.newDate, getCurrentDate()) === 2 || compareDates(variables.selectedDate.newDate, getCurrentDate()) === 0){
            await updateClass(object, variables.selectedItem.data)
        } else {
            showMessage("Debes seleccionar una fecha proxima", "warning")
        }
    }

    //Funcion que actualiza la clase
    const updateClass = async (data, prevData) => {
        await setDoc(doc(db, "ClaseMuestra", prevData.correo), data).then(async r => {
            
            await updateDoc(doc(db, data.ref), {
                clases_muestra: increment(1)
            }).then(async r2 => {

                if(!prevData.checked){
                    await updateDoc(doc(db, prevData.ref), {
                        clases_muestra: increment(-1)
                    }).then(r3 => {
    
                        setVariables(prev => ({
                            ...prev,
                            showAcademies: false,
                            selector: false,
                            selectedDate: null
                        }))
            
                        setTimeout(() => {
                            showMessage("Clase actualizada con exito", "success")
                            setTimeout(() => {
                                window.location.reload()
                            }, 1500)
                        }, 10)
    
                    }).catch(e => {
                        console.log(e)
                    })
                } else {
                    setVariables(prev => ({
                        ...prev,
                        showAcademies: false,
                        selector: false,
                        selectedDate: null
                    }))
        
                    setTimeout(() => {
                        showMessage("Clase actualizada con exito", "success")
                        setTimeout(() => {
                            window.location.reload()
                        }, 1500)
                    }, 10)
                }
            }).catch(e => {
                console.log(e)
            })
        }).catch(e => {
            console.log(e)
            showMessage("Error al modificar clase", "warning")
        })
    }

    const formatSubtitle = (v) => {
        if(v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP"){
            var dias = ""
            v.dias_clase.map(v => {
                var dia = ""
                var hora = v.de + "-" + v.a
                for(let i = 0; i < 3; i++){
                    dia += v.dia[i]
                }

                if(dias == ""){
                    dias = dia + " " + hora
                } else {
                    dias += " / " + dia + " " + hora
                }

            })

            return dias
        } else {
            return ""
        }
    }

    return (
        <div className='mainPlayersComponent' style={{
            opacity: variables.showAcademies ? 1 : 0,
            zIndex: variables.showAcademies ? 1 : -1000
        }}>
            <div className='playersCont'>
                <div style={{
                    width: "100%"
                }}>
                    <div style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        marginBottom: 20
                    }}>
                        <IoMdClose id='outplayer' size={20} color='#C00' onClick={() => setVariables(prev => ({
                            ...prev,
                            showAcademies: false,
                            selector: false
                        }))} style={{
                            cursor: "pointer"
                        }} />
                    </div>

                    <div className='contPlayers'>
                        {
                            variables.selector === false ?
                                <p style={{
                                    textAlign: "center",
                                    marginBottom: 10,
                                    fontFamily: fontType.title,
                                    fontSize: 18
                                }}>SELECCIONA EL CENTRO</p>
                            : 
                                <p style={{
                                    textAlign: "center",
                                    marginBottom: 10,
                                    fontFamily: fontType.title,
                                    fontSize: 18
                                }}>SELECCIONA LA CLASE</p>
                        }
                        {
                            variables.selector === false ?
                                variables.academias.map((v, i) => {
                                    return (
                                        <div className='player' onClick={() => {
                                            searchClasses(v)
                                        }}>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold"
                                            }}>{v.nombre_academia}</p>
                                        </div>
                                    )
                                })
                            :
                                variables.classes.map((v, i) => {
                                    return (
                                        <div className='player' onClick={() => selectCenter(v)}>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 18,
                                                fontWeight: "bold"
                                            }}>{v.nombre_clase}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 16
                                            }}>{formatSubtitle(v)}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 14,
                                                marginTop: 20
                                            }}>{v.nombre_profesor}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 12,
                                                fontStyle: "italic",
                                                textAlign: "right"
                                            }}>{v.numero_jugadores} | {v.limite_jugadores}</p>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Academias